import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18.17 13L15.59 15.59L17 17L22 12L17 7L15.59 8.41L18.17 11H2V13H18.17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongRight"
);
